export default __webpack_public_path__ + "static/media/2015_2.7cef5aba.PNG";